import { render, staticRenderFns } from "./ElementFactFunctionalTableColumn.vue?vue&type=template&id=6da658fa"
import script from "./ElementFactFunctionalTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementFactFunctionalTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports